function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { t } from '../i18n';
import { SvgIcon } from './SvgIcon';
var defaultProps = {
  className: '',
  viewBox: '0 0 52 64'
};
export function LockIcon(props) {
  var iconCssClasses = "ds-c-icon--lock ".concat(props.className || '');
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    title: t('icons.lock')
  }, defaultProps, props, {
    className: iconCssClasses
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M26 0c10.493 0 19 8.507 19 19v9h3a4 4 0 0 1 4 4v28a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V32a4 4 0 0 1 4-4h3v-9C7 8.507 15.507 0 26 0zm0 8c-5.979 0-10.843 4.77-10.996 10.712L15 19v9h22v-9c0-6.075-4.925-11-11-11z"
  }));
}